/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DataVaxiomPersonTitleValue/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function DataVaxiomPersonTitleValue({
  children,
  value,
  viewPath = "/DesignSystem/Data/DataVaxiom/DataVaxiomPerson/DataVaxiomPersonTitleValue",
  marginTop,
  marginBottom,
  text
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={marginTop || dtSpaceXxs}
 marginBottom={marginBottom || dtSpaceXxs}
 text={text}
/>
{children}
</React.Fragment>)
}